// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'

//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
axios.defaults.baseURL = "https://ceac.dotia.es";
if (new RegExp(['localhost', 'dev.', 'sandbox'].join("|")).test(location.host)) {
	axios.defaults.baseURL = 'https://sandbox-fp.dotia.es'
}
// if (new RegExp(['localhost'].join("|")).test(location.host)) {
// 	axios.defaults.baseURL = 'https://localhost:44379'
// }

let token = window.localStorage.getItem('_token');
if (!!token) {
	axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
}
//.AXIOS

//VEE-VALIDATE
import VeeValidate, { Validator } from 'vee-validate';
import validatorEs from '@/validator/es';
Validator.localize('es', validatorEs);
Vue.use(VeeValidate);
//.VEE-VALIDATE

Validator.extend('email', {
    validate: value => {

		let ok = false;

		ok = value.includes("@");
		if(ok){
			ok = value.includes(".")
		}

		if(ok){
			var regex = "\S*[\u00E0-\u00FC]\S*";
			let regexCompiled = new RegExp(regex);
			ok = !regexCompiled.test(value);
		}

		return ok;
    }
  });

import i18n from './i18n';


/*SENTRY*/
// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';
// Sentry.init({
// 	dsn: 'https://9873ae9e28a3452bb7dbeb6e49316e52@o393426.ingest.sentry.io/5242501',
// 	integrations: [new VueIntegration({ Vue, attachProps: true, logError:true })],
// });


import Multiselect from 'vue-multiselect'

// register globally
Vue.component('multiselect', Multiselect)


import dropzone from '@/components/parts/form/dropzone';
Vue.component('dropzone', dropzone)

import popupinfo from '@/components/parts/popup-info';
Vue.component('popup-info', popupinfo)

Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	i18n,
	store,
	VeeValidate,
	components: { App },
	template: '<App/>'
})

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/sw.js')
			.then(registration => {
				console.log('✅ Service Worker registrado con éxito:', registration.scope)
				// Verificar actualizaciones periódicamente
				setInterval(() => {
					registration.update()
				}, 60000) // Cada minuto

				// Inicializar notificaciones push después de registrar el service worker
				// Solo si el usuario está logueado
				if (store.getters.getLogged) {
					store.dispatch('initializePushNotifications').then(() => {
						// Verificar si ya hay una suscripción activa
						store.dispatch('checkPushSubscription')
					}).catch(error => {
						console.error('❌ Error al inicializar push notifications:', error)
					})
				}
			})
			.catch(error => {
				console.error('❌ Error al registrar el Service Worker:', error)
			})
	})
}

// Escuchar cambios en el estado de autenticación para inicializar push
store.watch(
	(state, getters) => getters.getLogged,
	(isLogged) => {
		if (isLogged && 'serviceWorker' in navigator) {
			// Esperar a que el service worker esté listo
			navigator.serviceWorker.ready.then(() => {
				store.dispatch('initializePushNotifications').then(() => {
					store.dispatch('checkPushSubscription')
				}).catch(error => {
					console.error('❌ Error al inicializar push notifications:', error)
				})
			})
		}
	}
)

// Inicializar servicio de notificaciones locales (fake)
import localNotificationService from '@/services/local-notifications'
if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.ready.then(() => {
			localNotificationService.initialize().then(() => {
				console.log('✅ Servicio de notificaciones locales inicializado')
			}).catch(error => {
				console.error('❌ Error al inicializar notificaciones locales:', error)
			})
		})
	})
}

// Manejar evento beforeinstallprompt para mostrar botón de instalación manual
let deferredPrompt
window.addEventListener('beforeinstallprompt', (e) => {
	// Prevenir el banner automático
	e.preventDefault()
	// Guardar el evento para usarlo después
	deferredPrompt = e
	// Mostrar botón de instalación personalizado
	showInstallButton()
})

// Función para mostrar botón de instalación
function showInstallButton() {
	// Crear botón de instalación si no existe
	if (!document.getElementById('pwa-install-button')) {
		const installButton = document.createElement('button')
		installButton.id = 'pwa-install-button'
		installButton.innerHTML = '📱 Instalar App'
		installButton.style.cssText = `
			position: fixed;
			bottom: 20px;
			right: 20px;
			background: #4DBA87;
			color: white;
			border: none;
			padding: 12px 24px;
			border-radius: 25px;
			font-size: 16px;
			font-weight: bold;
			cursor: pointer;
			box-shadow: 0 4px 6px rgba(0,0,0,0.3);
			z-index: 10000;
			display: none;
		`
		installButton.addEventListener('click', installApp)
		document.body.appendChild(installButton)
		// Mostrar el botón
		document.getElementById('pwa-install-button').style.display = 'block'
	}
}

// Función para instalar la app
function installApp() {
	if (deferredPrompt) {
		// Mostrar el prompt de instalación
		deferredPrompt.prompt()
		// Esperar a que el usuario responda
		deferredPrompt.userChoice.then((choiceResult) => {
			if (choiceResult.outcome === 'accepted') {
				console.log('✅ Usuario aceptó la instalación')
			} else {
				console.log('❌ Usuario rechazó la instalación')
			}
			// Limpiar el prompt
			deferredPrompt = null
			// Ocultar el botón
			const btn = document.getElementById('pwa-install-button')
			if (btn) btn.style.display = 'none'
		})
	}
}

// Ocultar botón si la app ya está instalada
window.addEventListener('appinstalled', () => {
	console.log('✅ PWA instalada')
	deferredPrompt = null
	const btn = document.getElementById('pwa-install-button')
	if (btn) btn.style.display = 'none'
})


// WEBPACK FOOTER //
// ./src/main.js